import React from 'react';
import Logo from '../../../assets/img/auth/logo.svg';

// Chakra imports
import { Flex, useColorModeValue, Heading, Box, Image } from '@chakra-ui/react';

// Custom components
import { HorizonLogo } from 'components/icons/Icons';
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand(props) {
  const { sidebarPos, mouseOver } = props;
  //   Chakra color mode
  let logoColor = useColorModeValue('navy.700', 'white');

  const GoToHome = (id) => {
    // console.log(id)
    const url = `/admin/default`;
    window.open(url, '_self');
  };

  return (
    <Flex align='center' direction='column'>
      {/* <HorizonLogo h='26px' w='175px' my='32px' color={logoColor} /> */}
      {sidebarPos || mouseOver ? (
        <Flex mb={2}>
          <Box width={9} height={9} ml={-5} mr={3} onClick={GoToHome}>
            <Image src={Logo} alt='Chemmanur Logo' onClick={GoToHome} />
          </Box>
          <Heading
            as='h2'
            size='lg'
            fontWeight='400'
            noOfLines={1}
            onClick={GoToHome}
          >
            Chemmanur
          </Heading>
        </Flex>
      ) : (
        <Box width={9} height={9} ml={-3.5} onClick={GoToHome}>
          <Image src={Logo} alt='Chemmanur Logo' />
        </Box>
      )}
    </Flex>
  );
}

export default SidebarBrand;
